import { useCallback, useRef } from 'react'
import StakingHero from './StakingHero'
import StakingVestingShedule from './StakingVestingSchedule'
import StakingBenefits from './StakingBenefits'
import Stake from './Stake'
import { StakingTarget } from './types'

export const STAKED_DECIMALS = 18

function Staking({ target }: { target: StakingTarget }) {
  const hasVestingSchedule = false

  const resultsRef = useRef<HTMLDivElement>(null)
  const calcInputsRef = useRef<HTMLDivElement>(null)

  const scrollToStake = useCallback(() => {
    if (calcInputsRef.current) {
      calcInputsRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  return (
    <div>
      <StakingHero target={target} scrollToStake={scrollToStake} />

      {/* TODO: uncomment when logic for investors is in place (sablier contracts) */}
      {hasVestingSchedule && <StakingVestingShedule />}

      <StakingBenefits target={target} scrollToStake={scrollToStake} />
      <Stake
        target={target}
        resultsRef={resultsRef}
        calcInputsRef={calcInputsRef}
      />
    </div>
  )
}

export default Staking
